import { Combobox } from "@/components/ui/combobox";
import { Label } from "@/components/ui/label";
import { BearDecimalInput } from "@/lib/form/ui";
import { SelectOptionItem } from "@/lib/models/ui";

interface GeneralContractFieldProps {
  basis: string;
  marketZoneId: string;
  deliveryTerms: string;
  marketZoneOptions: SelectOptionItem<string>[];
  marketZonesLoading: boolean;
  deliveryTermsOptions: SelectOptionItem<string>[];
  errorBasis?: string;
  errorMarketZone?: string;
  errorDeliveryTerms?: string;
  onChangeBasis: (v: string) => void;
  onChangeMarketZone: (v: string) => void;
  onChangeDeliveryTerms: (v: string) => void;
  isEditable: boolean;
}

/**
 * General-contract fields currently collected for Cash orders in the TT attach
 * flow. They mirror the GeneralContract model's own columns; on
 * TtOrderAssociatedMetaData they persist as `basis`, `market_zone_id` (a
 * MarketZone id) and `delivery_terms`.
 */
export function GeneralContractField({
  isEditable,
  basis,
  marketZoneId,
  deliveryTerms,
  marketZoneOptions,
  marketZonesLoading,
  deliveryTermsOptions,
  errorBasis,
  errorMarketZone,
  errorDeliveryTerms,
  onChangeBasis,
  onChangeMarketZone,
  onChangeDeliveryTerms,
}: GeneralContractFieldProps) {
  return (
    <div className="space-y-3">
      <div className="space-y-1">
        <BearDecimalInput
          disabled={!isEditable}
          label="Basis"
          name="ttv2-basis"
          step="0.01"
          value={basis}
          required
          error={errorBasis}
          onChange={(v) => onChangeBasis(v === null || v === undefined ? "" : String(v))}
        />
        {errorBasis && <p className="text-destructive text-xs">{errorBasis}</p>}
      </div>

      <div className="space-y-1">
        <Label className="flex items-center justify-between">
          <span>Market Zone</span>
          <span className="text-xs font-light italic">Required</span>
        </Label>
        <Combobox
          dwimOnChange
          isModal={false}
          placeholder="Select market zone..."
          options={marketZoneOptions}
          value={marketZoneId}
          onValueChange={onChangeMarketZone}
          disabled={marketZonesLoading || !isEditable}
          virtualizeList
          popoverClassName="w-[420px] h-[280px]"
        />
        {errorMarketZone && <p className="text-destructive text-xs">{errorMarketZone}</p>}
      </div>

      <div className="space-y-1">
        <Label className="flex items-center justify-between">
          <span>Delivery Terms</span>
          <span className="text-xs font-light italic">Required</span>
        </Label>
        <Combobox
          disabled={!isEditable}
          dwimOnChange
          isModal={false}
          placeholder="Select delivery terms..."
          options={deliveryTermsOptions}
          value={deliveryTerms}
          onValueChange={onChangeDeliveryTerms}
          virtualizeList
          popoverClassName="w-[420px] h-[280px]"
        />
        {errorDeliveryTerms && <p className="text-destructive text-xs">{errorDeliveryTerms}</p>}
      </div>
    </div>
  );
}
